import { assert } from 'superstruct';
import { callbackDataSchema } from '../../shares/types/callbackResponseType';
import { hideLoader } from '../../shares/lib/otpUtils';
import OTPProvider from './OTPProvider';
import { OTPConfig } from '../../shares/model/config';
import getCurrentGameSelected from '../../shares/lib/currentGameSelected';
import logger from '../../shares/lib/logger';

class CallbackOTPProvider extends OTPProvider {
  protected override otpConfig: OTPConfig;

  constructor(otpConfig: OTPConfig) {
    super(otpConfig);
    this.otpConfig = otpConfig;
  }

  async getOTP(gameId?: string): Promise<string | void> {
    return await this.callbackWithNonce(gameId);
  }

  private generateNonce(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  private async callbackWithNonce(gameId?: string): Promise<string | void> {
    const { callbackFn } = this.otpConfig;
    try {
      if (!callbackFn) {
        throw new Error('callbackFn is undefined in otpConfig');
      }

      const currentGameSelected = getCurrentGameSelected();
      const nonce = this.generateNonce();

      const otpResponse = await callbackFn(nonce, {
        gameId: gameId ? gameId : currentGameSelected.currentGameId,
      });

      if (!otpResponse) {
        throw new Error('Callback function is not defined or not a function');
      }

      assert(otpResponse, callbackDataSchema);

      if (otpResponse.nonce !== nonce) {
        throw new Error('Nonce mismatch!');
      }

      if (!otpResponse.otp) {
        throw new Error('OTP Not Found');
      }

      return otpResponse.otp;
    } catch (error) {
      //showError('Callback function OTP Generation failed', error);
      logger.error('CallbackOTPProvider callbackWithNonce error', { error });
      throw error;
    } finally {
      hideLoader();
    }
  }
}

export default CallbackOTPProvider;
